import { useQuery } from '@tanstack/react-query';

import type { IApiResponse } from '../../helpers/types/general';
import type { IPartyState } from '../../interface/state/IPartyState';
import { coreApi } from '../../lib/api-client';
import { partyKeys } from './party-keys';

/** Active political parties (~20 total, no paging needed). Used by party pickers. */
export function useActiveParties(options: { enabled?: boolean } = {}) {
	return useQuery({
		queryKey: partyKeys.active(),
		queryFn: async (): Promise<IPartyState[]> => {
			const { data } = await coreApi.get<IApiResponse<IPartyState[]>>('/api/v1/Party/active');
			return data?.data ?? [];
		},
		enabled: options.enabled ?? true,
		staleTime: 5 * 60 * 1000,
	});
}
